import "./SignIn.css";
import axios from "axios";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import LoadingAction from "../../../themes/LoadingAction/LoadingAction";
import * as links from "../../../utils/links";
import { AuthContext } from "../../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { Button, Input } from "antd";
import plushLogo from "../../../assets/images/logoSrc.jfif";
import lukeToysLogo from "../../../assets/images/luke-toys.png";
import landingVideo from "../../../assets/videos/landing.mp4";
import lukeVideo from "../../../assets/videos/luke-maquinas.mp4";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

const initialDataSignIn = {
  email: "",
  password: "",
  cpf: ""
};

const initErrorField = {
  email: undefined,
  password: undefined,
  cpf: undefined
};

const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const SignIn = (props) => {
  const { setDataUser, loading, notiMessage, setNotiMessage } =
    useContext(AuthContext);
  let navigate = useNavigate();

  // useEffect(() => {
  //     if (notiMessage) {
  //         setNotiMessage(null)
  //         NotificationManager.error(notiMessage, 'Hmm... ');
  //     }
  // }, [])

  const [dataAuth, setDataSingUp] = useState({ ...initialDataSignIn });
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [errorField, setErrorField] = useState({ ...initErrorField });
  const [isLoading, setIsLoading] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isLoginOpenFuncionario, setIsLoginOpenFunionario] = useState(false);
  const [isDemoOpen, setIsDemoOpen] = useState(false);
  const [demoIndex, setDemoIndex] = useState(0);
  const [demoErrors, setDemoErrors] = useState({});
  const [dashVideoErrors, setDashVideoErrors] = useState({});
  const [dashVideoCandidateIndex, setDashVideoCandidateIndex] = useState({ landing: 0, luke: 0 });
  const [dashMediaIndex, setDashMediaIndex] = useState(() => (Math.random() < 0.5 ? 0 : 1));
  const [isPlansOpen, setIsPlansOpen] = useState(false);
  const [plansStep, setPlansStep] = useState("kits");
  const [selectedKitKey, setSelectedKitKey] = useState(null);
  const [planImageErrors, setPlanImageErrors] = useState({});
  const [kitImageErrors, setKitImageErrors] = useState({});
  const [selectedVerse, setSelectedVerse] = useState(null);
  const [deferredInstallPrompt, setDeferredInstallPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);
  const [showIosInstallHint, setShowIosInstallHint] = useState(false);
  const dashVideoRef = useRef(null);

  const versiculos = useMemo(
    () => [
      {
        texto: "Entrega o teu caminho ao Senhor; confia nele, e ele tudo fará.",
        ref: "Salmos 37:5",
      },
      {
        texto: "O Senhor é quem te dá força para adquirir riquezas.",
        ref: "Deuteronômio 8:18",
      },
      {
        texto: "Confia no Senhor de todo o teu coração.",
        ref: "Provérbios 3:5",
      },
      {
        texto: "O Senhor te abençoará em tudo o que fizeres.",
        ref: "Deuteronômio 15:10",
      },
      {
        texto: "Os planos do diligente conduzem à fartura.",
        ref: "Provérbios 21:5",
      },
      {
        texto: "A bênção do Senhor é que enriquece.",
        ref: "Provérbios 10:22",
      },
      {
        texto: "Quem é fiel no pouco, também é fiel no muito.",
        ref: "Lucas 16:10",
      },
      {
        texto: "O Senhor é a minha luz e a minha salvação.",
        ref: "Salmos 27:1",
      },
      {
        texto: "Seja forte e corajoso.",
        ref: "Josué 1:9",
      },
      {
        texto: "Quem semeia com fé, colherá com alegria.",
        ref: "Salmos 126:5",
      },
    ],
    []
  );

  const publicBaseUrl = process.env.PUBLIC_URL || "";
  const buildVideoCandidates = (fileName) => {
    const appBaseFromScript = (() => {
      try {
        const scripts = Array.from(document.getElementsByTagName("script"));
        const script = scripts.find(
          (s) => typeof s.src === "string" && s.src.includes("/static/js/")
        );
        if (!script?.src) return null;
        const url = new URL(script.src);
        const idx = url.pathname.indexOf("/static/js/");
        const basePath = idx >= 0 ? url.pathname.slice(0, idx) : "";
        return `${url.origin}${basePath}`;
      } catch (_) {
        return null;
      }
    })();

    const rawCandidates = [
      appBaseFromScript ? `${appBaseFromScript}/demo/${fileName}` : null,
      `${publicBaseUrl}/demo/${fileName}`,
      `/demo/${fileName}`,
      `./demo/${fileName}`,
    ].filter(Boolean);
    const normalized = rawCandidates.map((v) =>
      v.startsWith("http") ? v : v.replace(/\/{2,}/g, "/")
    );
    return Array.from(new Set(normalized));
  };
  const dashVideoCandidates = useMemo(
    () => {
      const landing = [landingVideo, ...buildVideoCandidates("landing.mp4")];
      const luke = [lukeVideo, ...buildVideoCandidates("luke-maquinas.mp4")];
      return {
        landing: Array.from(new Set(landing)),
        luke: Array.from(new Set(luke)),
      };
    },
    [publicBaseUrl]
  );
  const kits = [
    {
      key: "kit1",
      nome: "Kit 1",
      sub: "Kit unitário",
      imgSrc: `${process.env.PUBLIC_URL}/demo/kit1.png`,
    },
    {
      key: "kit3",
      nome: "Kit 3",
      sub: "Kit inicial",
      imgSrc: `${process.env.PUBLIC_URL}/demo/kit3.png`,
    },
    {
      key: "kit5",
      nome: "Kit 5",
      sub: "Kit escala",
      imgSrc: `${process.env.PUBLIC_URL}/demo/kit5.png`,
    },
  ];

  const planosMensalidade = [
    {
      key: "mensal",
      nome: "Mensal",
      sub: "Sem fidelidade",
      preco: "R$ 40,00",
      por: "/ máquina",
      imgSrc: `${process.env.PUBLIC_URL}/demo/mensalplano.png`,
    },
    {
      key: "trimestral",
      nome: "Trimestral",
      sub: "Mais estabilidade",
      preco: "R$ 34,90",
      por: "/ máquina",
      imgSrc: `${process.env.PUBLIC_URL}/demo/trimestralplano.png`,
    },
    {
      key: "semestral",
      nome: "Semestral",
      sub: "Melhor custo-benefício",
      preco: "R$ 31,90",
      por: "/ máquina",
      imgSrc: `${process.env.PUBLIC_URL}/demo/semestralplano.png`,
    },
    {
      key: "anual",
      nome: "Anual",
      sub: "Máxima economia",
      preco: "R$ 29,90",
      por: "/ máquina",
      imgSrc: `${process.env.PUBLIC_URL}/demo/anualplano.png`,
    },
  ];

  const planosWhatsappBase = "https://wa.me/5547984861290?text=";
  const parceirosMaquinas = [
    {
      key: "plush-machine",
      nome: "Plush Machine",
      whatsappUrl:
        "https://api.whatsapp.com/send/?phone=5519991501104&text=Oi%2C%20vim%20pela%20p%C3%A1gina%20do%20sistema%20IKPay.%20Quero%20conhecer%20as%20m%C3%A1quinas%20que%20voc%C3%AA%20tem%20%C3%A0%20venda.",
      logoSrc: plushLogo,
    },
    {
      key: "luke-toys",
      nome: "Luke Toys",
      whatsappUrl:
        "https://api.whatsapp.com/send/?phone=558189834589&text=Oi%2C%20vim%20pela%20p%C3%A1gina%20do%20sistema%20IKPay.%20Quero%20conhecer%20as%20m%C3%A1quinas%20que%20voc%C3%AA%20tem%20%C3%A0%20venda.",
      logoSrc: lukeToysLogo,
    },
  ];

  const demoSlides = [
    {
      title: "Monitoramento",
      src: `${process.env.PUBLIC_URL}/demo/01-monitoramento.png`,
    },
    {
      title: "Pagamentos",
      src: `${process.env.PUBLIC_URL}/demo/02-pagamentos.png`,
    },
    {
      title: "Editar Máquina",
      src: `${process.env.PUBLIC_URL}/demo/03-editar-maquina.png`,
    },
    {
      title: "Adicionar Crédito",
      src: `${process.env.PUBLIC_URL}/demo/04-adicionar-credito.png`,
    },
    {
      title: "Disponibilidade",
      src: `${process.env.PUBLIC_URL}/demo/05-disponibilidade.png`,
    },
  ];

  const [partnerImageErrors, setPartnerImageErrors] = useState({});

  useEffect(() => {
    if (dashMediaIndex !== 0 && dashMediaIndex !== 1) return;
    if (!dashVideoRef.current) return;
    const key = dashMediaIndex === 0 ? "landing" : "luke";
    if (dashVideoErrors[key]) return;
    try {
      dashVideoRef.current.currentTime = 0;
      dashVideoRef.current.load();
      const playPromise = dashVideoRef.current.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(() => { });
      }
    } catch (_) { }
  }, [dashMediaIndex, dashVideoErrors, dashVideoCandidateIndex]);

  useEffect(() => {
    const storageKey = "ikpay_verse_index";
    const raw = window.localStorage.getItem(storageKey);
    let idx = Number.parseInt(raw ?? "0", 10);
    if (!Number.isFinite(idx) || idx < 0) idx = 0;
    const selected = versiculos[idx % versiculos.length];
    setSelectedVerse(selected);
    window.localStorage.setItem(storageKey, String((idx + 1) % versiculos.length));
  }, [versiculos]);

  const openPlans = () => {
    setPlansStep("kits");
    setSelectedKitKey(null);
    setIsPlansOpen(true);
  };

  const closePlans = () => {
    setIsPlansOpen(false);
    setPlansStep("kits");
    setSelectedKitKey(null);
  };

  useEffect(() => {
    const onBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredInstallPrompt(event);
      setShowInstallButton(true);
    };

    const onAppInstalled = () => {
      setDeferredInstallPrompt(null);
      setShowInstallButton(false);
    };

    window.addEventListener("beforeinstallprompt", onBeforeInstallPrompt);
    window.addEventListener("appinstalled", onAppInstalled);

    const ua = window.navigator.userAgent.toLowerCase();
    const isIos = /iphone|ipad|ipod/.test(ua);
    const isStandalone =
      (window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) ||
      window.navigator.standalone === true;
    const dismissed = window.localStorage.getItem("ikpay_ios_install_hint_dismissed") === "1";
    setShowIosInstallHint(isIos && !isStandalone && !dismissed);

    return () => {
      window.removeEventListener("beforeinstallprompt", onBeforeInstallPrompt);
      window.removeEventListener("appinstalled", onAppInstalled);
    };
  }, []);

  const onInstallClick = async () => {
    if (!deferredInstallPrompt) return;
    try {
      await deferredInstallPrompt.prompt();
      await deferredInstallPrompt.userChoice;
    } finally {
      setDeferredInstallPrompt(null);
      setShowInstallButton(false);
    }
  };

  const onsubmit = () => {
    let dataErrorField = {};
    if (dataAuth.email.trim() === "") {
      dataErrorField = {
        ...dataErrorField,
        email: "Email obrigatório.",
      };
    } else if (!validateEmail(dataAuth.email.trim())) {
      dataErrorField = {
        ...dataErrorField,
        email: "Email inválido.",
      };
    }
    if (dataAuth.password.trim() === "") {
      dataErrorField = {
        ...dataErrorField,
        password: "Senha obrigatória",
      };
    } else if (dataAuth.password.trim().length < 6) {
      dataErrorField = {
        ...dataErrorField,
        password: "Senha tem que ter no mínimo 6 dígitos.",
      };
    }

    setSuccess(false);
    if (Object.keys(dataErrorField).length === 0) {
      setIsLoading(true);
      setError(null);
      axios
        .post(`${process.env.REACT_APP_SERVIDOR}/login-cliente`, {
          senha: dataAuth.password,
          email: dataAuth.email.trim(),
        })
        .then((res) => {
          if (res.status === 200) {
            // setNotiMessage({
            //     type: 'success',
            //     message: 'Credito inserido com sucesso!'
            // })
            setIsLoading(false);
            setSuccess(true);
            setDataSingUp({
              ...initialDataSignIn,
            });
            setDataUser({
              ...res.data,
            });
            navigate(links.DASHBOARD_FORNECEDOR);
          } else {
            throw new Error();
          }
        })
        .catch((err) => {
          setIsLoading(false);
          // setNotiMessage({
          //     type: 'error',
          //     message: 'Desculpe aconteceu algum problema, não foi possível inserir o crédito remotamente'
          // })
          if (err.response.status === 500) {
            setError(
              'Usuário já existe, <a target="_blank" href=' +
              links.FORGOTPASSWORD +
              ">esqueceu sua senha<a/>?"
            );
          } else {
            setError(
              "Erro, algo deu errado " + (err.response?.data?.error ?? "")
            );
          }
        });
    } else {
      setErrorField((prev) => {
        return {
          ...prev,
          ...dataErrorField,
        };
      });
    }
  };


  const loginFuncionario = () => {
    let dataErrorField = {};
    if (dataAuth.cpf.trim() === "") {
      dataErrorField = {
        ...dataErrorField,
        cpf: "CPF obrigatório.",
      };
    } else if (dataAuth.cpf.length < 11) {
      dataErrorField = {
        ...dataErrorField,
        cpf: "CPF deve ter 11 dígitos.",
      };
    }
    if (dataAuth.password.trim() === "") {
      dataErrorField = {
        ...dataErrorField,
        password: "Senha obrigatória",
      };
    } else if (dataAuth.password.trim().length < 6) {
      dataErrorField = {
        ...dataErrorField,
        password: "Senha tem que ter no mínimo 6 dígitos.",
      };
    }

    setSuccess(false);
    if (Object.keys(dataErrorField).length === 0) {
      setIsLoading(true);
      setError(null);
      axios
        .post(`${process.env.REACT_APP_SERVIDOR}/login-funcionario`, {
          senha: dataAuth.password,
          cpf: dataAuth.cpf.trim(),
        })
        .then((res) => {
          if (res.status === 200) {
            setIsLoading(false);
            setSuccess(true);
            setDataSingUp({
              ...initialDataSignIn,
            });
            setDataUser({
              ...res.data,
            });
            navigate(links.DASHBOARD_FORNECEDOR);
          } else {
            throw new Error();
          }
        })
        .catch((err) => {
          setIsLoading(false);
          // setNotiMessage({
          //     type: 'error',
          //     message: 'Desculpe aconteceu algum problema, não foi possível inserir o crédito remotamente'
          // })
          if (err.response.status === 500) {
            setError(
              'Usuário já existe, <a target="_blank" href=' +
              links.FORGOTPASSWORD +
              ">esqueceu sua senha<a/>?"
            );
          } else {
            setError(
              "Erro, algo deu errado " + (err.response?.data?.error ?? "")
            );
          }
        });
    } else {
      setErrorField((prev) => {
        return {
          ...prev,
          ...dataErrorField,
        };
      });
    }
  };

  const openDashMedia = (index) => {
    setDashMediaIndex(index);
    if (index === 0 || index === 1) {
      const key = index === 0 ? "landing" : "luke";
      setDashVideoErrors((prev) => ({ ...prev, [key]: false }));
      setDashVideoCandidateIndex((prev) => ({ ...prev, [key]: 0 }));
    }
  };

  return (
    <>
      <NotificationContainer />
      {isLoading && <LoadingAction />}
      <div className="IkLanding_page" id="inicio">
        <header className="IkLanding_header">
          <div className="IkLanding_nav">
            <div className="IkLanding_brand" onClick={() => navigate(links.SIGNIN)}>
              <div className="IkLanding_brandMark">IKPAY</div>
              <div className="IkLanding_brandSub">Sistema</div>
            </div>

            <nav className="IkLanding_menu">
              <a className="IkLanding_menuLink" href="#inicio">
                INÍCIO
              </a>
              <a className="IkLanding_menuLink" href="#recursos">
                RECURSOS
              </a>
              <a className="IkLanding_menuLink" href="#funcionalidades">
                FUNCIONALIDADES
              </a>
              <a
                className="IkLanding_menuLink"
                href="#planos"
                onClick={(e) => {
                  e.preventDefault();
                  openPlans();
                }}
              >
                PLANOS
              </a>
              <a
                className="IkLanding_menuLink"
                href="https://wa.me/5547984861290?text=Ol%C3%A1!%20Gostaria%20de%20falar%20com%20voc%C3%AAs%20sobre%20o%20IKPay%20Sistema."
                target="_blank"
                rel="noopener noreferrer"
              >
                CONTATO
              </a>
            </nav>

            <div className="IkLanding_navCtas">
              <Button
  className="IkLanding_installCta"
  type="primary"
  onClick={() => {
    window.location.href = "/ikpay-control.apk";
  }}
>
  BAIXAR APP
</Button>
              <Button className="IkLanding_loginCta" type="primary" onClick={() => setIsLoginOpen(true)}>
                ACESSO CLIENTE
              </Button>
              <Button className="IkLanding_loginCta" type="primary" onClick={() => setIsLoginOpenFunionario(true)}>
                ACESSO FUNCIONÁRIO
              </Button>
            </div>
          </div>
        </header>

        <main className="IkLanding_main">
          <section className="IkLanding_hero">
            <div className="IkLanding_heroLeft">
              <h1 className="IkLanding_title">
                Praticidade na operação.
                <br />
                Visão total do seu negócio.
              </h1>
              <div className="IkLanding_subtitle">
                Receba via PIX, cartão, débito, crédito e espécie. O recebimento cai direto na conta bancária do
                cliente.
              </div>

              <div className="IkLanding_payBadges">
                <div className="IkLanding_payBadge">
                  <div className="IkLanding_payText">
                    <span className="IkLanding_payDot" aria-hidden="true" />
                    <span className="IkLanding_payEmoji" aria-hidden="true">
                      ⚡
                    </span>
                    PIX
                  </div>
                </div>
                <div className="IkLanding_payBadge">
                  <div className="IkLanding_payText">
                    <span className="IkLanding_payDot" aria-hidden="true" />
                    <span className="IkLanding_payEmoji" aria-hidden="true">
                      💳
                    </span>
                    Cartões
                  </div>
                </div>
                <div className="IkLanding_payBadge">
                  <div className="IkLanding_payText">
                    <span className="IkLanding_payDot" aria-hidden="true" />
                    <span className="IkLanding_payEmoji" aria-hidden="true">
                      💵
                    </span>
                    Espécie
                  </div>
                </div>
                <div className="IkLanding_payBadge">
                  <div className="IkLanding_payText">
                    <span className="IkLanding_payDot" aria-hidden="true" />
                    <span className="IkLanding_payEmoji" aria-hidden="true">
                      📦
                    </span>
                    Controle de estoque
                  </div>
                </div>
              </div>

              <div className="IkLanding_ctaRow">
                <button
                  className="IkLanding_ctaPrimary"
                  type="button"
                  onClick={() => {
                    setDemoIndex(0);
                    setIsDemoOpen(true);
                  }}
                >
                  VER DEMONSTRAÇÃO
                </button>
              </div>

              <div className="IkLanding_trustRow">
                <div className="IkLanding_trustItem">Relatórios inteligentes</div>
                <div className="IkLanding_trustItem">Visão remota</div>
                <div className="IkLanding_trustItem">Operação simples</div>
                <div className="IkLanding_trustItem">Você recebe direto na sua conta bancária.</div>
              </div>
            </div>

            <div className="IkLanding_heroRight">
              <div className="IkLanding_dashboardCard">
                <div className="IkLanding_dashTop">
                  <div className="IkLanding_dashBrand">Vídeo demonstrativo</div>
                  <div className="IkLanding_dashTopRight">
                    {[0, 1, 2].map((index) => (
                      <button
                        key={index}
                        type="button"
                        className={`IkLanding_dashDot${dashMediaIndex === index ? " IkLanding_dashDotActive" : ""}`}
                        aria-label={`Abrir mídia ${index + 1}`}
                        onClick={() => openDashMedia(index)}
                      />
                    ))}
                  </div>
                </div>

                <div className="IkLanding_dashVideoWrap">
                  {dashMediaIndex === 0 || dashMediaIndex === 1 ? (
                    dashVideoErrors[dashMediaIndex === 0 ? "landing" : "luke"] ? (
                      <div className="IkLanding_dashVideoMissing">
                        <div className="IkLanding_dashVideoMissingTitle">Vídeo não encontrado</div>
                        <div className="IkLanding_dashVideoMissingText">
                          Salve o arquivo em <b>src/assets/videos</b> (recomendado) ou <b>public/demo</b> com o nome{" "}
                          <b>{dashMediaIndex === 0 ? "landing.mp4" : "luke-maquinas.mp4"}</b>.
                        </div>
                      </div>
                    ) : (
                      (() => {
                        const key = dashMediaIndex === 0 ? "landing" : "luke";
                        const idx = dashVideoCandidateIndex[key] ?? 0;
                        const src = dashVideoCandidates[key]?.[idx] ?? "";
                        return (
                          <video
                            ref={dashVideoRef}
                            key={`${key}-${idx}`}
                            className="IkLanding_dashVideo"
                            src={src}
                            autoPlay
                            muted
                            playsInline
                            preload="metadata"
                            onEnded={() => {
                              const nextIndex = dashMediaIndex === 0 ? 1 : 2;
                              openDashMedia(nextIndex);
                            }}
                            onError={() => {
                              const nextIdx = idx + 1;
                              if (dashVideoCandidates[key] && nextIdx < dashVideoCandidates[key].length) {
                                setDashVideoCandidateIndex((prev) => ({ ...prev, [key]: nextIdx }));
                                return;
                              }
                              setDashVideoErrors((prev) => ({ ...prev, [key]: true }));
                            }}
                          />
                        );
                      })()
                    )
                  ) : (
                    <a
                      className="IkLanding_dashBanner"
                      href="https://wa.me/5547984861290?text=Ol%C3%A1!%20Tenho%20interesse%20em%20parceria%20com%20o%20IKPay%20Sistema."
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="IkLanding_dashBannerKicker">Parceiros</div>
                      <div className="IkLanding_dashBannerTitle">Vagas para parceria em aberto</div>
                      <div className="IkLanding_dashBannerText">Aproveite!!!</div>
                      <div className="IkLanding_dashBannerCta">Falar no WhatsApp</div>
                    </a>
                  )}
                </div>

                <div className="IkLanding_partnerBlock">
                  <div className="IkLanding_partnerTitle">Compre sua máquina com um fabricante parceiro abaixo ↓</div>
                  {parceirosMaquinas.map((parceiro) => (
                    <a
                      key={parceiro.key}
                      className="IkLanding_partnerLink"
                      href={parceiro.whatsappUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="IkLanding_partnerCard">
                        {parceiro.logoSrc && !partnerImageErrors[parceiro.key] ? (
                          <img
                            className={`IkLanding_partnerLogo${parceiro.key === "luke-toys" ? " IkLanding_partnerLogoTight" : ""}`}
                            src={parceiro.logoSrc}
                            alt={parceiro.nome}
                            onError={() =>
                              setPartnerImageErrors((prev) => ({ ...prev, [parceiro.key]: true }))
                            }
                          />
                        ) : (
                          <div className="IkLanding_partnerLogoPlaceholder">LOGO</div>
                        )}
                        {parceiro.key === "luke-toys" ? (
                          <div className="IkLanding_partnerName IkLanding_partnerNameLuke">
                            <span className="IkLanding_partnerLukeWord">
                              <span className="IkLanding_partnerLukeL">L</span>
                              <span className="IkLanding_partnerLukeU">U</span>
                              <span className="IkLanding_partnerLukeK">K</span>
                              <span className="IkLanding_partnerLukeE">E</span>
                            </span>
                            <span className="IkLanding_partnerLukeWord">
                              <span className="IkLanding_partnerLukeT">T</span>
                              <span className="IkLanding_partnerLukeO">O</span>
                              <span className="IkLanding_partnerLukeY">Y</span>
                              <span className="IkLanding_partnerLukeS">S</span>
                            </span>
                          </div>
                        ) : parceiro.key === "plush-machine" ? (
                          <div className="IkLanding_partnerName IkLanding_partnerNamePlush">
                            <span className="IkLanding_partnerPlushPrimary">Plush</span>
                            <span className="IkLanding_partnerPlushSecondary">Machine</span>
                          </div>
                        ) : (
                          <div className="IkLanding_partnerName">{parceiro.nome}</div>
                        )}
                      </div>
                    </a>
                  ))}
                  <a
                    className="IkLanding_partnerSecondaryCta"
                    href="https://wa.me/5547984861290?text=Ol%C3%A1!%20Gostaria%20de%20falar%20com%20voc%C3%AAs%20sobre%20o%20IKPay%20Sistema."
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Seja nosso parceiro também
                  </a>
                </div>
              </div>
            </div>
          </section>

          <section className="IkLanding_section" id="recursos">
            <div className="IkLanding_sectionTitle">Tudo o que você precisa, em um só sistema.</div>
            <div className="IkLanding_sectionSubtitle">
              Painel completo com relatórios, controle e visão remota para acompanhar a operação.
            </div>

            <div className="IkLanding_featureGrid">
              <div className="IkLanding_featureCard">
                <div className="IkLanding_featureIcon">📈</div>
                <div className="IkLanding_featureName">Relatórios inteligentes</div>
                <div className="IkLanding_featureText">Exportação e visão clara para tomada de decisão.</div>
              </div>
              <div className="IkLanding_featureCard">
                <div className="IkLanding_featureIcon">🧾</div>
                <div className="IkLanding_featureName">Recibos e histórico</div>
                <div className="IkLanding_featureText">Acompanhe transações por data, máquina e cliente.</div>
              </div>
              <div className="IkLanding_featureCard">
                <div className="IkLanding_featureIcon">📡</div>
                <div className="IkLanding_featureName">Visão remota</div>
                <div className="IkLanding_featureText">Controle e monitoramento em tempo real da operação.</div>
              </div>
              <div className="IkLanding_featureCard">
                <div className="IkLanding_featureIcon">🔒</div>
                <div className="IkLanding_featureName">Segurança</div>
                <div className="IkLanding_featureText">Controle de acesso e registros para auditoria.</div>
              </div>
            </div>
          </section>

          <section className="IkLanding_section" id="funcionalidades">
            <div className="IkLanding_sectionTitle">Funcionalidades</div>
            <div className="IkLanding_sectionSubtitle">
              Recursos para transformar a gestão do seu negócio com operação simples e rápida.
            </div>

            <div className="IkLanding_funcGrid">
              <div className="IkLanding_funcCard">
                <div className="IkLanding_funcName">Recebimento via PIX</div>
                <div className="IkLanding_funcText">Pagamento rápido e com baixa fricção no atendimento.</div>
              </div>
              <div className="IkLanding_funcCard">
                <div className="IkLanding_funcName">Débito e crédito</div>
                <div className="IkLanding_funcText">Aceite cartão e acompanhe tudo pelo painel.</div>
              </div>
              <div className="IkLanding_funcCard">
                <div className="IkLanding_funcName">Entrada em espécie</div>
                <div className="IkLanding_funcText">Registro de operações e relatórios completos.</div>
              </div>
              <div className="IkLanding_funcCard">
                <div className="IkLanding_funcName">Controle de estoque</div>
                <div className="IkLanding_funcText">Saiba por qual valor o seu produto está saindo.</div>
              </div>
              <div className="IkLanding_funcCard">
                <div className="IkLanding_funcName">Gestão de máquinas</div>
                <div className="IkLanding_funcText">Cadastre, organize e acompanhe suas máquinas.</div>
              </div>
              <div className="IkLanding_funcCard">
                <div className="IkLanding_funcName">Clientes e permissões</div>
                <div className="IkLanding_funcText">Controle por cliente e histórico centralizado.</div>
              </div>
              <div className="IkLanding_funcCard">
                <div className="IkLanding_funcName">Ative a jogada bônus</div>
                <div className="IkLanding_funcText">
                  Ativação em todas as formas: Pix, cartões e também espécie. Você decide como vai aceitar o bônus.
                </div>
              </div>
              <div className="IkLanding_funcCard">
                <div className="IkLanding_funcName">Exportar PDF</div>
                <div className="IkLanding_funcText">Relatórios e comprovantes prontos para imprimir.</div>
              </div>
            </div>
          </section>

          <section className="IkLanding_section" id="planos">
            <div className="IkLanding_sectionTitle">Planos</div>
            <div className="IkLanding_sectionSubtitle">Fale com a gente para escolher o melhor modelo para sua operação.</div>

            <div className="IkLanding_planCard">
              <div className="IkLanding_planName">Plano sob medida</div>
              <div className="IkLanding_planText">
                Implantação e suporte para sua operação. Recebimento direto na conta bancária do cliente.
              </div>
              <button className="IkLanding_planOpen" type="button" onClick={openPlans}>
                Ver kits e planos
              </button>
              <a
                className="IkLanding_planCta"
                href="https://wa.me/5547984861290?text=Gostaria%20de%20um%20or%C3%A7amento%20do%20IKPay%20Sistema."
                target="_blank"
                rel="noopener noreferrer"
              >
                Solicitar orçamento
              </a>
            </div>

            {selectedVerse && (
              <div className="IkLanding_verseCard" aria-label="Versículo do dia">
                <div className="IkLanding_verseTitle">Versículo do dia</div>
                <div className="IkLanding_verseText">“{selectedVerse.texto}”</div>
                <div className="IkLanding_verseRef">— {selectedVerse.ref}</div>
              </div>
            )}
          </section>
        </main>

        <footer className="IkLanding_footer" id="contato">
          <div className="IkLanding_footerInner">
            <div className="IkLanding_footerBrand">IKPAY Sistema</div>
            <div className="IkLanding_footerStats">
              <div className="IkLanding_footerStat">
                <div className="IkLanding_footerStatValue">1000+</div>
                <div className="IkLanding_footerStatLabel">máquinas conectadas</div>
              </div>
              <div className="IkLanding_footerStat">
                <div className="IkLanding_footerStatValue">2 anos</div>
                <div className="IkLanding_footerStatLabel">ativo</div>
              </div>
              <div className="IkLanding_footerStat">
                <div className="IkLanding_footerStatValue">24h</div>
                <div className="IkLanding_footerStatLabel">sem interrupções</div>
              </div>
            </div>
          </div>
        </footer>
      </div>

      {showIosInstallHint && (
        <div className="IkLanding_a2hsHint" role="dialog" aria-label="Adicionar à tela de início">
          <div className="IkLanding_a2hsHintText">
            No iPhone: toque em Compartilhar e depois em &quot;Adicionar à Tela de Início&quot;.
          </div>
          <button
            className="IkLanding_a2hsHintClose"
            type="button"
            onClick={() => {
              window.localStorage.setItem("ikpay_ios_install_hint_dismissed", "1");
              setShowIosInstallHint(false);
            }}
            aria-label="Fechar"
          >
            ×
          </button>
        </div>
      )}

      {isLoginOpen && (
        <div
          className="IkLanding_loginOverlay"
          onClick={() => {
            setIsLoginOpen(false);
          }}
          role="button"
          tabIndex={-1}
        >
          <div
            className="IkLanding_loginModal"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label="Acessar sistema"
          >
            <div className="IkLanding_loginModalHeader">
              <div className="IkLanding_loginModalTitle">Acessar sistema</div>
              <button className="IkLanding_loginClose" onClick={() => setIsLoginOpen(false)} type="button">
                ×
              </button>
            </div>

            {!!error && (
              <div className="IkLanding_loginError">
                <div dangerouslySetInnerHTML={{ __html: error }}></div>
              </div>
            )}

            <div className="IkLanding_loginField">
              <div className="IkLanding_loginLabel">E-mail</div>
              <Input
                placeholder="Digite seu e-mail"
                value={dataAuth?.email ?? ""}
                onChange={(e) => {
                  const value = e.target.value;
                  setDataSingUp((prev) => ({ ...prev, email: value }));
                  setErrorField((prev) => ({ ...prev, email: undefined }));
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") onsubmit();
                }}
              />
              {!!errorField?.email && <div className="IkLanding_loginFieldError">{errorField.email}</div>}
            </div>

            <div className="IkLanding_loginField">
              <div className="IkLanding_loginLabel">Senha</div>
              <Input.Password
                placeholder="Digite sua senha"
                value={dataAuth?.password ?? ""}
                onChange={(e) => {
                  const value = e.target.value;
                  setDataSingUp((prev) => ({ ...prev, password: value }));
                  setErrorField((prev) => ({ ...prev, password: undefined }));
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") onsubmit();
                }}
              />
              {!!errorField?.password && <div className="IkLanding_loginFieldError">{errorField.password}</div>}
            </div>

            <Button type="primary" block className="IkLanding_loginSubmit" onClick={onsubmit}>
              Entrar
            </Button>

            <div className="IkLanding_loginLinks">
              <a href={links.FORGOTPASSWORD}>Esqueceu a senha?</a>
              <a href={links.SIGNUP_CANAL}>Criar cadastro</a>
            </div>
          </div>
        </div>
      )}

      {isLoginOpenFuncionario && (
        <div
          className="IkLanding_loginOverlay"
          onClick={() => {
            setIsLoginOpenFunionario(false);
          }}
          role="button"
          tabIndex={-1}
        >
          <div
            className="IkLanding_loginModal"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label="Acessar sistema"
          >
            <div className="IkLanding_loginModalHeader">
              <div className="IkLanding_loginModalTitle">Acessar sistema</div>
              <button className="IkLanding_loginClose" onClick={() => setIsLoginOpenFunionario(false)} type="button">
                ×
              </button>
            </div>

            {!!error && (
              <div className="IkLanding_loginError">
                <div dangerouslySetInnerHTML={{ __html: error }}></div>
              </div>
            )}

            <div className="IkLanding_loginField">
              <div className="IkLanding_loginLabel">CPF</div>
              <Input
                placeholder="000.000.000-00"
                value={dataAuth?.cpf ?? ""}
                onChange={(e) => {
                  const value = e.target.value;
                  setDataSingUp((prev) => ({ ...prev, cpf: value }));
                  setErrorField((prev) => ({ ...prev, cpf: undefined }));
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") onsubmit();
                }}
              />
              {!!errorField?.cpf && <div className="IkLanding_loginFieldError">{errorField.cpf}</div>}
            </div>

            <div className="IkLanding_loginField">
              <div className="IkLanding_loginLabel">Senha</div>
              <Input.Password
                placeholder="Digite sua senha"
                value={dataAuth?.password ?? ""}
                onChange={(e) => {
                  const value = e.target.value;
                  setDataSingUp((prev) => ({ ...prev, password: value }));
                  setErrorField((prev) => ({ ...prev, password: undefined }));
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") onsubmit();
                }}
              />
              {!!errorField?.password && <div className="IkLanding_loginFieldError">{errorField.password}</div>}
            </div>

            <Button type="primary" block className="IkLanding_loginSubmit" onClick={()=> loginFuncionario()}>
              Entrar
            </Button>

            <div className="IkLanding_loginLinks">
              <a href={links.FORGOTPASSWORD}>Esqueceu a senha?</a>
              <a href={links.SIGNUP_CANAL}>Criar cadastro</a>
            </div>
          </div>
        </div>
      )}

      {isDemoOpen && (
        <div
          className="IkLanding_demoOverlay"
          onClick={() => {
            setIsDemoOpen(false);
          }}
          role="button"
          tabIndex={-1}
        >
          <div
            className="IkLanding_demoModal"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label="Demonstração"
          >
            <div className="IkLanding_demoHeader">
              <div className="IkLanding_demoTitle">Demonstração</div>
              <button className="IkLanding_demoClose" onClick={() => setIsDemoOpen(false)} type="button">
                ×
              </button>
            </div>

            <div className="IkLanding_demoBody">
              <div className="IkLanding_demoTopRow">
                <div className="IkLanding_demoStep">
                  {demoIndex + 1}/{demoSlides.length} • {demoSlides[demoIndex]?.title}
                </div>
                <div className="IkLanding_demoNav">
                  <Button
                    className="IkLanding_demoNavBtn"
                    onClick={() => setDemoIndex((prev) => Math.max(0, prev - 1))}
                    disabled={demoIndex === 0}
                  >
                    Anterior
                  </Button>
                  <Button
                    type="primary"
                    className="IkLanding_demoNavBtnPrimary"
                    onClick={() => setDemoIndex((prev) => Math.min(demoSlides.length - 1, prev + 1))}
                    disabled={demoIndex === demoSlides.length - 1}
                  >
                    Próximo
                  </Button>
                </div>
              </div>

              <div className="IkLanding_demoImageWrap">
                {demoErrors[demoIndex] ? (
                  <div className="IkLanding_demoMissing">
                    <div className="IkLanding_demoMissingTitle">Imagem de demonstração não encontrada</div>
                    <div className="IkLanding_demoMissingText">
                      Coloque os arquivos em <b>public/demo</b> com estes nomes:
                      <div className="IkLanding_demoMissingList">
                        01-monitoramento.png, 02-pagamentos.png, 03-editar-maquina.png, 04-adicionar-credito.png,
                        05-disponibilidade.png
                      </div>
                    </div>
                  </div>
                ) : (
                  <img
                    className="IkLanding_demoImage"
                    src={demoSlides[demoIndex]?.src}
                    alt={demoSlides[demoIndex]?.title}
                    onError={() => {
                      setDemoErrors((prev) => ({ ...prev, [demoIndex]: true }));
                    }}
                  />
                )}
              </div>

              <div className="IkLanding_demoThumbs">
                {demoSlides.map((slide, index) => (
                  <button
                    key={slide.src}
                    type="button"
                    className={`IkLanding_demoThumb ${index === demoIndex ? "IkLanding_demoThumbActive" : ""}`}
                    onClick={() => setDemoIndex(index)}
                    title={slide.title}
                  >
                    <img
                      className="IkLanding_demoThumbImg"
                      src={slide.src}
                      alt={slide.title}
                      onError={(e) => {
                        e.currentTarget.style.visibility = "hidden";
                      }}
                    />
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {isPlansOpen && (
        <div
          className="IkLanding_plansOverlay"
          onClick={() => {
            closePlans();
          }}
          role="button"
          tabIndex={-1}
        >
          <div
            className="IkLanding_plansModal"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label="Planos de mensalidade"
          >
            <div className="IkLanding_plansHeader">
              <div className="IkLanding_plansHeaderLeft">
                {plansStep === "planos" && (
                  <button
                    className="IkLanding_plansBack"
                    type="button"
                    onClick={() => {
                      setPlansStep("kits");
                      setSelectedKitKey(null);
                    }}
                  >
                    ← Voltar
                  </button>
                )}
                <div className="IkLanding_plansTitle">
                  {plansStep === "kits" ? "Escolha seu kit" : "Agora escolha o plano mensal"}
                </div>
              </div>
              <button className="IkLanding_plansClose" onClick={closePlans} type="button">
                ×
              </button>
            </div>

            {plansStep === "kits" ? (
              <div className="IkLanding_plansGrid">
                {kits.map((kit) => {
                  const missing = !!kitImageErrors[kit.key];
                  return (
                    <div key={kit.key} className="IkLanding_plansCard">
                      {!missing ? (
                        <img
                          className="IkLanding_plansImg"
                          src={kit.imgSrc}
                          alt={`${kit.nome} - ${kit.sub}`}
                          onError={() => setKitImageErrors((prev) => ({ ...prev, [kit.key]: true }))}
                        />
                      ) : (
                        <div className="IkLanding_plansFallback">
                          <div className="IkLanding_plansName">{kit.nome}</div>
                          <div className="IkLanding_plansSub">{kit.sub}</div>
                        </div>
                      )}

                      <button
                        className="IkLanding_plansCtaBtn"
                        type="button"
                        onClick={() => {
                          setSelectedKitKey(kit.key);
                          setPlansStep("planos");
                        }}
                      >
                        Escolher {kit.nome}
                      </button>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="IkLanding_plansGrid">
                {planosMensalidade.map((plano) => {
                  const kit = kits.find((k) => k.key === selectedKitKey);
                  const kitLabel = kit ? `${kit.nome}` : "Kit";
                  const link = `${planosWhatsappBase}${encodeURIComponent(
                    `Olá! Quero o ${kitLabel} e o plano ${plano.nome} (${plano.preco}${plano.por}).`
                  )}`;
                  const missing = !!planImageErrors[plano.key];
                  return (
                    <div key={plano.key} className="IkLanding_plansCard">
                      {!missing ? (
                        <img
                          className="IkLanding_plansImg"
                          src={plano.imgSrc}
                          alt={`${plano.nome} - ${plano.preco} ${plano.por}`}
                          onError={() => setPlanImageErrors((prev) => ({ ...prev, [plano.key]: true }))}
                        />
                      ) : (
                        <div className="IkLanding_plansFallback">
                          <div className="IkLanding_plansName">{plano.nome}</div>
                          <div className="IkLanding_plansSub">{plano.sub}</div>
                          <div className="IkLanding_plansPrice">
                            <span className="IkLanding_plansPriceValue">{plano.preco}</span>{" "}
                            <span className="IkLanding_plansPriceUnit">{plano.por}</span>
                          </div>
                          <div className="IkLanding_plansFeatures">
                            <div className="IkLanding_plansFeature">Acesso total ao sistema</div>
                            <div className="IkLanding_plansFeature">Suporte especializado</div>
                            <div className="IkLanding_plansFeature">Atualizações constantes</div>
                          </div>
                        </div>
                      )}

                      <a className="IkLanding_plansCta" href={link} target="_blank" rel="noopener noreferrer">
                        Escolher {plano.nome}
                      </a>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default SignIn;
